import Tag from '../../../../components/Display/Tag';
import { getImage } from '../../../../utils/imageHelper';
import moment from 'moment';
import { Star } from 'lucide-react';
import styles from "../../cards.module.scss"

function ProjectItem({ project, handleClickProject, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickProject}>
      <img
        className={styles.projectImage}
        src={project.images[0]?.file ? project.images[0].file : getImage('img-ph.png')}
        alt={project.images[0]?.label ? project.images[0].label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{project.title}</p>
          <span className={styles.subtitle}>{`${project.city}, ${moment(project.date).format('LL')}`}</span>

          <span className={styles.subtitle}>{project.client}</span>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: project.is_highlight && 'Projet mis en avant',
              icon: Star,
              bgColor: project.is_highlight && 'bg-green-700'
            }}
            rounded
          />
        </div>
      </div>
    </div>
  );
}

export default ProjectItem;
